import ReactPaginate from 'react-paginate';
import { FC } from 'react';

export const DEFAULT_PER_PAGE = 80;
const pageSizes = [10, 20, 40, 80];

interface IProps {
  totalPages: number;
  page: number;
  totalItems?: string;
  perPage?: number;
  onChangePerPage?: (count: number) => void | null;
  onChangePage: (selectedItem: { selected: number }) => void;
}

const Paginator: FC<IProps> = ({
  totalPages,
  page,
  onChangePage,
  totalItems,
  perPage = null,
  onChangePerPage = null,
}) => {
  return (
    <div className="w-full flex justify-between">
      <div className="flex items-center gap-[8px]">
        {perPage ? (
          <>
            <div>Показывать</div>
            {pageSizes.map((item, index) => (
              <PaginatorPageSizeItem
                key={index}
                count={item}
                isActive={item === perPage}
                onClick={onChangePerPage ?? (() => {})}
              />
            ))}
          </>
        ) : null}
      </div>
      <div>
        {totalItems ? (
          <span className="opacity-[50%] text-[14px] text-[#FFFFFF] pr-[15px]">{totalItems}</span>
        ) : null}
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          initialPage={page}
          onPageChange={onChangePage}
          pageRangeDisplayed={2}
          previousLinkClassName="relative inline-flex items-center rounded-l-md px-[10px] py-[4px]  ring-inset focus:z-20 focus:outline-offset-0"
          nextLinkClassName="relative inline-flex items-center rounded-r-md px-[10px] py-[4px] ring-inset  focus:z-20 focus:outline-offset-0"
          pageClassName="relative inline-flex items-center text-[14px] px-[10px] py-[4px] font-semibold ring-inset  focus:z-20 focus:outline-offset-0"
          activeClassName="bg-[#211F24] font-semibold text-white focus:z-20 rounded-[8px]"
          pageCount={totalPages}
          containerClassName="isolate inline-flex -space-x-px rounded-md shadow-xs"
          previousLabel="<"
          renderOnZeroPageCount={null}
        />
      </div>
    </div>
  );
};

interface IPaginatorPageSizeItemProps {
  count: number;
  isActive: boolean;
  onClick: (count: number) => void;
}
const PaginatorPageSizeItem: FC<IPaginatorPageSizeItemProps> = ({ count, isActive, onClick }) => {
  return (
    <div
      className={`cursor-pointer text-[14px] px-[8px] py-[4px] ${isActive ? 'bg-[#211F24] rounded-[8px]' : ''}`}
      onClick={() => onClick(count)}
    >
      {count}
    </div>
  );
};

export default Paginator;
